/** Teksty nagłówków widoków (Hero 2.0): grupa fin. Klucze: heroFin.* */
export const heroFinPl = {
  cmp: { prev: 'poprz.', yoy: 'r/r' },
  actions: { customersTab: 'Rentowność klientów', routes: 'Rentowność tras', routeCustomers: 'Klienci trasy', allRoutes: 'Wszystkie trasy' },
  margin: {
    sales: 'Sprzedaż',
    margin: 'Marża',
    marginPct: 'Marża %',
    realProfit: 'Zysk rzeczywisty',
    corrections: 'Korekty (KOR)',
    ppHint: '{pp} vs {cmp}',
    realProfitHint: 'rentowność {pct}',
    correctionsHint: '{pct} sprzedaży',
    insightLoss: 'Po kosztach transportu i innych kosztach okres zamyka się stratą {amount} — sprawdź rentowność klientów i tras.',
    insightDrop: 'Marża spadła z {from} do {to} ({pp}) — zajrzyj do rozbicia niżej, by znaleźć klientów i produkty, które ją obniżyły.',
    insightCorrections: 'Korekty pochłaniają {pct} sprzedaży ({amount}) — warto sprawdzić, skąd tyle zwrotów i rabatów.',
    insightUp: 'Marża rośnie: {to} wobec {from} ({pp}). Utrzymaj strukturę sprzedaży.',
    insightDefault: 'Marża na poziomie {pct} — bez wyraźnych odchyleń od okresu porównawczego.',
    seeProfitability: 'Rentowność',
  },
  profit: {
    sales: 'Sprzedaż',
    realProfit: 'Zysk rzeczywisty',
    realProfitPct: 'Rentowność',
    lossCustomers: 'Klienci ze stratą',
    lossHint: 'strata łącznie {amount} · {low} o niskiej rentowności',
    realProfitHint: 'po kosztach transportu',
    customersHint: '{count} klientów w analizie',
    insightLoss: '{count} klientów przynosi stratę (łącznie {amount}). Zacznij od przyczyn: małe zamówienia, dystans, transport.',
    insightLow: '{count} klientów ma rentowność poniżej progu — rozważ minimum zamówienia lub zmianę trasy.',
    insightOk: 'Portfel klientów rentowny: {pct} zysku rzeczywistego, bez klientów ze stratą.',
    showLoss: 'Pokaż stratnych',
    showLow: 'Pokaż niskorentownych',
    routes: {
      revenue: 'Przychód tras',
      profit: 'Zysk z tras',
      profitability: 'Rentowność tras',
      onTime: 'Punktualność',
      revenueHint: '{count} tras · {deliveries} dostaw',
      profitHint: 'koszt tras {cost}',
      onTimeHint: 'dostawy w terminie',
      insightLoss: '{count} tras jest nierentownych — najgorsza: {name} ({pct}). Sprawdź koszt na kilometr i obsadzenie.',
      insightWeak: '{count} tras ma słabą rentowność — najsłabsza: {name} ({pct}).',
      insightOk: 'Wszystkie trasy rentowne — najlepsza: {name} ({pct}).',
      seeRoute: 'Szczegóły trasy',
    },
  },
  route: {
    revenue: 'Przychód',
    profit: 'Zysk trasy',
    profitability: 'Rentowność',
    onTime: 'Punktualność',
    revenueHint: '{count} dostaw',
    profitHint: 'koszt trasy {cost}',
    profitabilityHint: '{pp} vs poprz. okres',
    onTimeHint: 'nieudane dostawy: {count}',
    cost: { fuel: 'paliwo', driver: 'kierowca', vehicle: 'pojazd', other: 'inne koszty' },
    insightLoss: 'Trasa jest nierentowna ({amount}). Największy koszt: {driver} ({share} kosztów trasy).',
    insightLossCustomers: '{count} klientów na trasie nie pokrywa kosztu dojazdu (łącznie {amount}).',
    insightDrop: 'Rentowność trasy spadła ({pp}) względem poprzedniego okresu.',
    insightWeak: 'Trasa jest na granicy opłacalności ({pct}) — sprawdź koszt na kilometr i skład klientów.',
    insightOk: 'Trasa rentowna: {pct} zysku po kosztach trasy.',
  },
  rec: {
    open: 'Należności',
    overdue: 'Przeterminowane',
    dso: 'DSO',
    overLimit: 'Ponad limit',
    openHint: '{count} otwartych faktur',
    overdueHint: '{pct} należności · {count} faktur',
    dsoHint: 'dni do zapłaty',
    overLimitHint: '{count} dłużników łącznie',
    insightOld: '{count} dłużników zalega ponad 60 dni na {amount} — zacznij od {name} ({debt}, {days} dni).',
    insightLimit: '{count} klientów przekroczyło limit kredytowy — wstrzymaj nowe zamówienia do wyjaśnienia płatności.',
    insightDebtors: '{count} klientów ma przeterminowane faktury ({amount}) — krótki kontakt przypomni o płatności.',
    insightOk: 'Należności pod kontrolą: brak przeterminowanych faktur.',
    openCustomer: 'Karta klienta',
  },
  fc: {
    sales: 'Sprzedaż w miesiącu',
    forecast: 'Prognoza końca miesiąca',
    probability: 'Szansa na cel',
    pace: 'Wymagane tempo / dzień',
    salesHint: 'cel {target}',
    salesNoTarget: 'brak celu',
    forecastHint: '{pct} celu',
    paceHint: 'obecnie {avg} / dzień',
    paceDone: 'cel osiągnięty',
    paceNoTarget: 'brak celu',
    insightAchieved: 'Cel miesiąca osiągnięty — prognoza {pct} celu.',
    insightOnTrack: 'Na dobrej drodze: prognoza {pct} celu. Utrzymaj tempo {avg} / dzień.',
    insightAtRisk: 'Cel zagrożony: prognoza {pct}, zabraknie około {amount}. Potrzeba {required} / dzień, a jest {avg}.',
    insightOffTrack: 'Cel poza zasięgiem przy obecnym tempie: prognoza {pct}, brakuje {amount}. Potrzeba {required} / dzień, a jest {avg}.',
    insightNoTarget: 'Brak ustalonego celu na ten miesiąc — prognoza {forecast} przy obecnym tempie.',
    behindReps: '{count} handlowców poniżej planu — najsłabszy: {name} ({pct}).',
    showRep: 'Pokaż: {name}',
  },
};

export const heroFinEn: typeof heroFinPl = {
  cmp: { prev: 'prev.', yoy: 'YoY' },
  actions: { customersTab: 'Customer profitability', routes: 'Route profitability', routeCustomers: 'Route customers', allRoutes: 'All routes' },
  margin: {
    sales: 'Sales',
    margin: 'Margin',
    marginPct: 'Margin %',
    realProfit: 'Real profit',
    corrections: 'Corrections (credit notes)',
    ppHint: '{pp} vs {cmp}',
    realProfitHint: 'profitability {pct}',
    correctionsHint: '{pct} of sales',
    insightLoss: 'After transport and other costs the period closes with a loss of {amount} — check customer and route profitability.',
    insightDrop: 'Margin fell from {from} to {to} ({pp}) — see the breakdown below to find the customers and products that pulled it down.',
    insightCorrections: 'Corrections eat {pct} of sales ({amount}) — worth checking where the returns and discounts come from.',
    insightUp: 'Margin is rising: {to} vs {from} ({pp}). Keep the sales mix.',
    insightDefault: 'Margin at {pct} — no clear deviation from the comparison period.',
    seeProfitability: 'Profitability',
  },
  profit: {
    sales: 'Sales',
    realProfit: 'Real profit',
    realProfitPct: 'Profitability',
    lossCustomers: 'Loss-making customers',
    lossHint: 'total loss {amount} · {low} with low profitability',
    realProfitHint: 'after transport costs',
    customersHint: '{count} customers analysed',
    insightLoss: '{count} customers are loss-making (total {amount}). Start with the causes: small orders, distance, transport.',
    insightLow: '{count} customers are below the profitability threshold — consider a minimum order or a route change.',
    insightOk: 'Healthy customer portfolio: {pct} real profit and no loss-making customers.',
    showLoss: 'Show loss-makers',
    showLow: 'Show low-profit',
    routes: {
      revenue: 'Route revenue',
      profit: 'Route profit',
      profitability: 'Route profitability',
      onTime: 'On-time rate',
      revenueHint: '{count} routes · {deliveries} deliveries',
      profitHint: 'route cost {cost}',
      onTimeHint: 'deliveries on time',
      insightLoss: '{count} routes are unprofitable — the worst is {name} ({pct}). Check cost per km and load.',
      insightWeak: '{count} routes have weak profitability — the weakest is {name} ({pct}).',
      insightOk: 'All routes are profitable — the best is {name} ({pct}).',
      seeRoute: 'Route details',
    },
  },
  route: {
    revenue: 'Revenue',
    profit: 'Route profit',
    profitability: 'Profitability',
    onTime: 'On-time rate',
    revenueHint: '{count} deliveries',
    profitHint: 'route cost {cost}',
    profitabilityHint: '{pp} vs previous period',
    onTimeHint: 'failed deliveries: {count}',
    cost: { fuel: 'fuel', driver: 'driver', vehicle: 'vehicle', other: 'other costs' },
    insightLoss: 'The route is unprofitable ({amount}). Biggest cost: {driver} ({share} of route costs).',
    insightLossCustomers: '{count} customers on the route do not cover the cost of getting there (total {amount}).',
    insightDrop: 'Route profitability dropped ({pp}) vs the previous period.',
    insightWeak: 'The route is close to break-even ({pct}) — check cost per km and the customer mix.',
    insightOk: 'Profitable route: {pct} profit after route costs.',
  },
  rec: {
    open: 'Receivables',
    overdue: 'Overdue',
    dso: 'DSO',
    overLimit: 'Over limit',
    openHint: '{count} open invoices',
    overdueHint: '{pct} of receivables · {count} invoices',
    dsoHint: 'days to payment',
    overLimitHint: '{count} debtors in total',
    insightOld: '{count} debtors are over 60 days late with {amount} — start with {name} ({debt}, {days} days).',
    insightLimit: '{count} customers exceeded their credit limit — hold new orders until the payment is sorted out.',
    insightDebtors: '{count} customers have overdue invoices ({amount}) — a short call will remind them to pay.',
    insightOk: 'Receivables under control: no overdue invoices.',
    openCustomer: 'Customer card',
  },
  fc: {
    sales: 'Sales this month',
    forecast: 'Month-end forecast',
    probability: 'Chance of target',
    pace: 'Required pace / day',
    salesHint: 'target {target}',
    salesNoTarget: 'no target',
    forecastHint: '{pct} of target',
    paceHint: 'now {avg} / day',
    paceDone: 'target reached',
    paceNoTarget: 'no target',
    insightAchieved: 'Monthly target reached — forecast is {pct} of target.',
    insightOnTrack: 'On track: forecast {pct} of target. Keep the pace of {avg} / day.',
    insightAtRisk: 'Target at risk: forecast {pct}, about {amount} short. You need {required} / day, you have {avg}.',
    insightOffTrack: 'Target out of reach at the current pace: forecast {pct}, {amount} short. You need {required} / day, you have {avg}.',
    insightNoTarget: 'No target set for this month — forecast {forecast} at the current pace.',
    behindReps: '{count} reps are behind plan — the weakest is {name} ({pct}).',
    showRep: 'Show: {name}',
  },
};
